import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { db } from "../firebase.config";
import { collection, addDoc } from "firebase/firestore";
import { Grid, Paper, Avatar, Typography, TextField, Button, Stack } from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const paperStyle = {
  padding: 20,
  height: "auto",
  width: 400,
  margin: "20px auto",
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
  backgroundColor: "#FFFFFF",
};

const avatarStyle = {
  bgcolor: "#1E2761",
};

const buttonStyle = {
  bgcolor: "#1E2761",
  color: "#FFFFFF",
  width: "100%",
  marginTop: 20,
  '&:hover': {
    bgcolor: '#142a52',
  },
};

const SignUp = () => {
  const location = useLocation();
  const { email, displayName } = location.state; // Get email and displayName from Google login
  const [userDetails, setUserDetails] = useState({ email: email || "", displayName: displayName || "" });
  const navigate = useNavigate();

  const handleSignUp = async () => {
    try {
      // Add user to Firestore
      await addDoc(collection(db, "UserProfileMaster"), {
        userEmail: userDetails.email,
        email: userDetails.email,
        displayName: userDetails.displayName,
        Is_Active: true,
        isAdmin: false, // New users are not admins by default
        createdAt: new Date(),
      });

      alert("Account created successfully. Please log in.");
      navigate("/"); // Redirect to SignIn page
    } catch (error) {
      console.error("Error signing up: ", error);
      alert("Error creating account. Please try again.");
    }
  };

  return (
    <Grid container justifyContent="center" alignContent="center" sx={{ bgcolor: "#1E2761", height: "100vh" }}>
      <Paper elevation={10} style={paperStyle}>
        <Stack direction="column" spacing={2} alignItems="center">
          <Avatar sx={avatarStyle}>
            <PersonAddIcon />
          </Avatar>
          <Typography variant="h4" color="#1E2761" textAlign="center">
            Complete Sign Up
          </Typography>

          <TextField
            label="Full Name"
            variant="outlined"
            fullWidth
            value={userDetails.displayName}
            onChange={(e) => setUserDetails({ ...userDetails, displayName: e.target.value })}
            required
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={userDetails.email}
            disabled
            required
          />

          <Button
            type="button"
            variant="contained"
            fullWidth
            sx={buttonStyle}
            onClick={handleSignUp}
          >
            Complete Signup
          </Button>
        </Stack>
      </Paper>
    </Grid>
  );
};

export default SignUp;
